import { render, staticRenderFns } from "./IrrigationWaterSources.vue?vue&type=template&id=368aa430&scoped=true"
import script from "./IrrigationWaterSources.vue?vue&type=script&lang=js"
export * from "./IrrigationWaterSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368aa430",
  null
  
)

export default component.exports